import { render, staticRenderFns } from "./settings-menu.vue?vue&type=template&id=19d6a044&"
import script from "./settings-menu.vue?vue&type=script&lang=ts&setup=true&"
export * from "./settings-menu.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/Desktop/business/EFM/02 RCP/code/rcp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d6a044')) {
      api.createRecord('19d6a044', component.options)
    } else {
      api.reload('19d6a044', component.options)
    }
    module.hot.accept("./settings-menu.vue?vue&type=template&id=19d6a044&", function () {
      api.rerender('19d6a044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/pages/settings/settings-menu.vue"
export default component.exports